import { ISiteRouter } from '@/ISiteRouter';
import Base from './Base.vue';
import BlockPage from './BlockPage.vue';
import Support from './Support.vue';

const comingSoonEnabled = false;
const headerConfig = {
  colorClass: 'grey',
  foreground: '#FFFFFF',
  items: [
    {
      url: '/#Home',
      name: 'Home',
    },
    {
      url: '/#AboutUs',
      name: 'About Us',
    },
    {
      url: '/#GetInTouch',
      name: 'Contact Us',
    },
    {
      url: '/Support',
      name: 'Support',
    },
    // {
    //   url: 'https://news.bettercorp.co.za/',
    //   name: 'News',
    // },
    // {
    //   url: 'https://store.bettercorp.co.za/',
    //   name: 'Store',
    // },
    // {
    //   url: 'https://manage.bettercorp.co.za/',
    //   name: 'Portal',
    // },
    {
      url: 'https://sophos.bettertech.co.za/',
      name: 'Sophos',
      button: true,
      buttonClass: 'internal',
    },
    {
      url: 'https://bettercorp.co.za/',
      name: 'BetterCorp',
      button: true,
      buttonClass: 'core',
    },
  ],
  logo: {
    url: '/img/betterCorp-Logo-White.svg',
    width: 150,
    height: 60,
  },
};
const footerConfig = {
  socialIcons: [
    {
      url: 'https://fb.com/BetterCorp',
      icon: 'fa fa-facebook',
    },
  ],
};
const thisHostname = 'bettercorp.co.za';

export default {
  config: {
    companyName: 'BetterTech by BetterCorp',
    companyThemeColour: 'rgb(0, 145, 234)',
    companyDescription: 'BetterCorp is a services company here to better your life.',
    companyKeywords: ['bettercorp', 'services', 'south africa', 'better', 'ninja', 'betterninja', 'betterweb', 'betterfibre'],
    companyIcons: {
      'Large': '/bcorp-icons/apple-icon.png',
      '192x192': '/bcorp-icons/android-icon-192x192.png',
      '76x76': '/bcorp-icons/apple-icon-76x76.png',
      '120x120': '/bcorp-icons/apple-icon-120x120.png',
      '152x152': '/bcorp-icons/apple-icon-152x152.png',
      '310x310': '/bcorp-icons/ms-icon-310x310.png',
      '70x70': '/bcorp-icons/ms-icon-70x70.png',
      '150x150': '/bcorp-icons/ms-icon-150x150.png',
    },
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./Home.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          ...headerConfig,
          hideOnInitial: true,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '/RMM/Blocked/',
      name: 'Blocked',
      component: BlockPage,
      meta: {
        host: thisHostname,
        comingSoon: false,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '/Support/',
      name: 'Support',
      component: Support,
      meta: {
        host: thisHostname,
        comingSoon: false,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    // {
    //   path: '/ContactUs',
    //   name: 'ContactUs',
    //   component: () => import('./ContactUs.vue'),
    //   meta: {
    //     host: thisHostname,
    //     comingSoon: comingSoonEnabled,
    //     base: Base,
    //     headerConfig: {
    //       hideOnInitial: false,
    //       ...headerConfig,
    //     },
    //     footerConfig: {
    //       ...footerConfig,
    //     },
    //   },
    // },
    // {
    //   path: '/Portal/Login',
    //   name: 'Portal Login',
    //   component: () => import('./PortalLogin.vue'),
    //   meta: {
    //     host: thisHostname,
    //     comingSoon: comingSoonEnabled,
    //     base: Base,
    //     headerConfig: {
    //       hideOnInitial: false,
    //       ...headerConfig,
    //     },
    //     footerConfig,
    //   },
    // },
    {
      path: '*',
      name: 'Not found',
      component: () => import('./Home.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
  ],
} as ISiteRouter;
